import { z, type ZodType } from 'zod';

export type GetFromLocalStorageInputWithSchema<T> = {
  scope: string;
  key: string;
  schema?: ZodType<T>;
};

export const boardConfigSchema = z.object({
  segmentWidth: z.number(),
});

export type BoardConfigSchema = z.infer<typeof boardConfigSchema>;
